if (!customElements.get('product-social-proof')) {
  class ProductSocialProof extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.items = Array.from(this.querySelectorAll('[data-social-proof-item]'));
      this.activeIndex = 0;
      this.previousIndex = -1;

      if (!this.items.length) return;

      const productId = this.dataset.productId || 'product';

      this.items.forEach((item) => {
        const firstValue = Number.parseInt(item.dataset.minCount, 10) || 0;
        const secondValue = Number.parseInt(item.dataset.maxCount, 10) || 0;
        const minCount = Math.max(0, Math.min(firstValue, secondValue));
        const maxCount = Math.max(0, Math.max(firstValue, secondValue));
        const metric = item.dataset.socialProofKey || 'metric';
        const count = this.getStableValue(`${productId}:${metric}`, minCount, maxCount);
        const countElement = item.querySelector('[data-social-proof-count]');

        if (countElement) countElement.textContent = String(count);
      });

      this.showItem(0);

      if (this.items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const interval = Math.max(2000, Number.parseInt(this.dataset.rotationInterval, 10) || 2600);
        this.rotationTimer = window.setInterval(() => {
          this.showItem((this.activeIndex + 1) % this.items.length);
        }, interval);
      }
    }

    disconnectedCallback() {
      if (this.rotationTimer) window.clearInterval(this.rotationTimer);
      this.rotationTimer = null;
      this.dataset.initialized = 'false';
    }

    getStableValue(value, minCount, maxCount) {
      let hash = 2166136261;

      for (let index = 0; index < value.length; index += 1) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
      }

      return minCount + ((hash >>> 0) % (maxCount - minCount + 1));
    }

    showItem(index) {
      this.previousIndex = this.activeIndex;
      this.activeIndex = index;

      this.items.forEach((item, itemIndex) => {
        const isActive = itemIndex === this.activeIndex;
        const isPrevious = itemIndex === this.previousIndex && this.previousIndex !== this.activeIndex;

        item.dataset.state = isActive ? 'active' : isPrevious ? 'exit' : 'idle';
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }
  }

  customElements.define('product-social-proof', ProductSocialProof);
}
